import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';

// Renders ```mermaid fenced code blocks in TechDocs pages as diagrams. TechDocs serves static
// HTML and the reader strips scripts, so a client-side addon is the supported way to draw them.
// Mirrors how @backstage/plugin-techdocs-module-addons-contrib registers its addons in the new
// frontend system (AddonBlueprint + createFrontendModule, pluginId "techdocs").
const mermaidAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: {
    name: 'Mermaid',
    location: TechDocsAddonLocations.Content,
    component: Mermaid,
  },
});

export const mermaidModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [mermaidAddon],
});
